import { render, staticRenderFns } from "./DeptCascader.vue?vue&type=template&id=d5034328&scoped=true"
import script from "./DeptCascader.vue?vue&type=script&lang=js"
export * from "./DeptCascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5034328",
  null
  
)

export default component.exports